import React, { useReducer, Fragment, useEffect, useState } from "react";
import {
  CustodianEntityReducer,
  initializeCustodianEntity,
  defaultStateEntity,
  ValidateCustodianEntity,
  resetClearingHouse,
} from "./reducer";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Container,
  Row,
  Col,
  Input,
  Button,
  Table,
  Label,
  UncontrolledDropdown,
  DropdownMenu,
  DropdownItem,
  DropdownToggle,
} from "reactstrap";
import style from "./CustodianEntity.module.scss";
import CircularProgress from "../../CircularProgress/CircularProgress";
import { Field, Combobox } from "../Order/Field/Field";
import LaddaButton, { EXPAND_RIGHT } from "react-ladda";
import classnames from "classnames";
import CustodianEntityContact from "./CustodianEntityContact";
import CustodianEntityClearingHouse from "./CustodianEntityClearingHouse";
import CustodianEntityCodeType from "./CustodianEntityCodeType";

const CustodianEntity = ({ open, toggle, fetchs, ...props }) => {
  const [state, dispatch] = useReducer(
    CustodianEntityReducer,
    defaultStateEntity(),
    initializeCustodianEntity(props)
  );
  const {
    custodian,
    errors,
    openCustodianEntityContact,
    openCustodianEntityClearingHouse,
    openCustodianEntityCodeType,
    EditClearingHouse,
    EditCodeType,
    EditContact,
    loadingConfirmCustodianEntity,
    messageConfirmCustodianEntity,
  } = state;
  const [loading, setLoading] = useState(false);
  const [messageErrors, setMessageErrors] = useState([]);

  useEffect(() => {
    setLoading(true);
    dispatch({ type: "RESET_CUSTODIAN_ENTITY" });

    if (props.isEditCustodianEntity) {
      props.callApi("GetTaxDocument", {}).then((response) => {
        dispatch({ type: "SET_TAX_DOCUMENT", response });

        props.callApi("GetCountries", {}).then((response) => {
          dispatch({ type: "SET_COUNTRIES", response });

          props
            .callApi("GetCustodianEntityEdit", {
              custodianEntityId: props.entityId,
            })
            .then((response) => {
              dispatch({ type: "GET_CUSTODIAN_ENTITY", response });
              setLoading(false);
            });
        });
      });
    } else {
      props.callApi("GetTaxDocument", {}).then((response) => {
        dispatch({ type: "SET_TAX_DOCUMENT", response });
        props.callApi("GetCountries", {}).then((response) => {
          dispatch({ type: "SET_COUNTRIES", response });
          setLoading(false);
        });
      });
    }
  }, []);

  const confirm = () => {
    const errors = ValidateCustodianEntity(state);
    if (errors == false) {
      dispatch({ type: "UPDATE_VALIDATION_CONTACT_FORM", errors });
      dispatch({
        type: "UPDATE_FIELDS",
        fields: { loadingConfirmCustodianEntity: true },
      });
      //fijarnos si hay por lo menos un clearing house y un contact
      if (props.isEditCustodianEntity) {
        props
          .callApi("UpdateCustodianEntity", {
            custodianEntityId: props.entityId,
            custodianEntity: custodian,
          })
          .then((response) => {
            if (response.result.length > 0) {
              setMessageErrors(response.result);
            }
            dispatch({
              type: "UPDATE_FIELDS",
              fields: {
                loadingConfirmCustodianEntity: false,
                messageConfirmCustodianEntity: true,
              },
            });
          });
      } else {
        props.callApi("SetCustodianEntity", { custodianEntity: custodian }).then((response) => {
          if (response.result.length > 0) {
            setMessageErrors(response.result);
          }
          dispatch({
            type: "UPDATE_FIELDS",
            fields: {
              loadingConfirmCustodianEntity: false,
              messageConfirmCustodianEntity: true,
            },
          });
          props.RechargeCustodianEntity(response.custodianEntityId);
        });
      }
    } else {
      dispatch({ type: "UPDATE_VALIDATION_CONTACT_FORM", errors });
    }
  };
  const onChange = (fields) => dispatch({ type: "CHANGE_FIELDS", fields });
  const onChangeUpdate = (fields) => dispatch({ type: "UPDATE_FIELDS", fields });
  const setContact = (action) => dispatch({ type: "SET_CONTACT", action });
  const setClearingHouse = (action) => dispatch({ type: "SET_CLEARING_HOUSE_FORM", action });
  const updateClearingHouse = (action) => dispatch({ type: "UPDATE_CLEARING_HOUSE", action });
  const updateCodeType = (action) => dispatch({ type: "UPDATE_CODE_TYPE", action });
  const setCodeType = (action) => dispatch({ type: "SET_CODE_TYPE_FORM", action });
  const updateContact = (action) => dispatch({ type: "UPDATE_CONTACT", action });
  const deleteContact = (action) => dispatch({ type: "DELETE_CONTACT", action });
  const deleteClearingHouse = (action) => dispatch({ type: "DELETE_CLEARING_HOUSE", action });
  const deleteCodeType = (action) => dispatch({ type: "DELETE_CODE_TYPE", action });

  return (
    <Modal isOpen={open} style={{ maxWidth: "900px" }}>
      <ModalHeader toggle={toggle}>
        {props.isEditCustodianEntity ? "Update Custodian Entity" : "New Custodian Entity"}
      </ModalHeader>
      <Container>
        {loading ? (
          <CircularProgress />
        ) : (
          <React.Fragment>
            <Row>
              <Col lg={4} xs={12}>
                <Field label={"Name"} error={errors.CustodianEntityName}>
                  <Input
                    type={"text"}
                    placeholder={"Name"}
                    value={custodian.CustodianEntityName || ""}
                    invalid={errors.CustodianEntityName}
                    disabled={props.isEditCustodianEntity}
                    onChange={(e) => onChange({ CustodianEntityName: e.target.value })}
                  />
                </Field>
              </Col>
              <Col lg={4} xs={12}>
                <Field label={"Legal Institution Code"} error={errors.LegalInstitutionCode}>
                  <Input
                    type={"text"}
                    placeholder={"Legal Institution Code"}
                    value={custodian.LegalInstitutionCode || ""}
                    invalid={errors.LegalInstitutionCode}
                    onChange={(e) => onChange({ LegalInstitutionCode: e.target.value })}
                  />
                </Field>
              </Col>
              <Col lg={4} xs={12}>
                <Field label={"Legal Custodian Code"} error={errors.LegalCustodianCode}>
                  <Input
                    type={"text"}
                    placeholder={"Legal Custodian Code"}
                    value={custodian.LegalCustodianCode || ""}
                    invalid={errors.LegalCustodianCode}
                    onChange={(e) => onChange({ LegalCustodianCode: e.target.value })}
                  />
                </Field>
              </Col>
            </Row>
            <Row>
              <Col lg={4} xs={12}>
                <Field label={"Country"} error={errors.CountryId}>
                  <Combobox
                    style={{ background: "#edf9ff", fontWeight: 500 }}
                    value={custodian.CountryId}
                    invalid={errors.CountryId}
                    onChange={(v) => onChange({ CountryId: v })}
                    items={Object.values(custodian.countries).map((key, index) => ({
                      id: key.id,
                      description: key.name,
                    }))}
                  />
                </Field>
              </Col>
              <Col lg={4} xs={12}>
                <Field label={"Address"}>
                  <Input
                    type={"text"}
                    placeholder={"Address"}
                    value={custodian.CustodianEntityAddress || ""}
                    onChange={(e) => onChange({ CustodianEntityAddress: e.target.value })}
                  />
                </Field>
              </Col>
              <Col lg={4} xs={12}>
                <Field label={"URL"}>
                  <Input
                    type={"text"}
                    placeholder={"URL"}
                    value={custodian.CustodianEntityURL || ""}
                    onChange={(e) => onChange({ CustodianEntityURL: e.target.value })}
                  />
                </Field>
              </Col>
            </Row>
            <Row>
              <Col lg={4} xs={12}>
                <Field label={"Tax Document"}>
                  <Combobox
                    style={{ background: "#edf9ff", fontWeight: 500 }}
                    value={custodian.CustodianEntityTaxDocument}
                    onChange={(v) => onChange({ CustodianEntityTaxDocument: v })}
                    items={Object.values(custodian.taxDocument).map((key, index) => ({
                      id: [key],
                      description: [key],
                    }))}
                  />
                </Field>
              </Col>
              <Col lg={4} xs={12}>
                <Field label={"Tax"} error={errors.CustodianEntityTAXId}>
                  <Input
                    type={"text"}
                    placeholder={"Tax"}
                    value={custodian.CustodianEntityTAXId || ""}
                    invalid={errors.CustodianEntityTAXId}
                    onChange={(e) => onChange({ CustodianEntityTAXId: e.target.value })}
                  />
                </Field>
              </Col>
              <Col lg={4} xs={12}>
                <Field label={"Pending Limit"} error={errors.CustodianEntityPendingLimit}>
                  <Input
                    type={"number"}
                    placeholder={"Pending Limit"}
                    value={custodian.CustodianEntityPendingLimit || ""}
                    invalid={errors.CustodianEntityPendingLimit}
                    onChange={(e) => onChange({ CustodianEntityPendingLimit: e.target.value })}
                  />
                </Field>
              </Col>
            </Row>
            <Row>
              <Col lg={4} xs={12}>
                <Field label={"Swift"}>
                  <Input
                    type={"text"}
                    placeholder={"Swift"}
                    value={custodian.CustodianEntitySwift || ""}
                    onChange={(e) => onChange({ CustodianEntitySwift: e.target.value })}
                  />
                </Field>
              </Col>
              <Col lg={4} xs={12}>
                <Field label={"Introduce by"}>
                  <Input
                    type={"text"}
                    placeholder={"Introduce by"}
                    value={custodian.CustodianEntityIntroducedBy || ""}
                    onChange={(e) => onChange({ CustodianEntityIntroducedBy: e.target.value })}
                  />
                </Field>
              </Col>
              <Col lg={4} xs={12}>
                <Field label={"Reference"}>
                  <Input
                    type={"text"}
                    placeholder={"Reference"}
                    value={custodian.CustodianEntityReference || ""}
                    onChange={(e) => onChange({ CustodianEntityReference: e.target.value })}
                  />
                </Field>
              </Col>
            </Row>
            <Row className={style.alignCombo}>
              <Col lg={4} xs={12}>
                <Label check>
                  <Input
                    type="checkbox"
                    checked={custodian.CustodianEntityIsExchangeListed}
                    value={custodian.CustodianEntityIsExchangeListed}
                    onClick={(e) =>
                      onChange({
                        CustodianEntityIsExchangeListed: !custodian.CustodianEntityIsExchangeListed,
                      })
                    }
                  />{" "}
                  Is Exchange Listed?
                </Label>
              </Col>
              <Col lg={4} xs={12}>
                <Label check>
                  <Input
                    type="checkbox"
                    checked={custodian.CustodianEntityHasInvestmentGrade}
                    value={custodian.CustodianEntityHasInvestmentGrade}
                    onClick={(e) =>
                      onChange({
                        CustodianEntityHasInvestmentGrade: !custodian.CustodianEntityHasInvestmentGrade,
                      })
                    }
                  />{" "}
                  Has Investment Grade?
                </Label>
              </Col>
              <Col lg={4} xs={12}>
                <Label check>
                  <Input
                    type="checkbox"
                    checked={custodian.CustodianEntityIsBank}
                    value={custodian.CustodianEntityIsBank}
                    onClick={(e) =>
                      onChange({
                        CustodianEntityIsBank: !custodian.CustodianEntityIsBank,
                      })
                    }
                  />{" "}
                  Is Local Bank?
                </Label>
              </Col>
            </Row>
            <Row>
              <Col>
                <Field label={"Notes"}>
                  <Input
                    type={"textarea"}
                    placeholder={"Notes"}
                    value={custodian.CustodianEntityNotes || ""}
                    onChange={(e) => onChange({ CustodianEntityNotes: e.target.value })}
                  />
                </Field>
              </Col>
            </Row>
            {openCustodianEntityContact ? (
              <div></div>
            ) : (
              <Row>
                <Col>
                  <Button
                    color="primary"
                    className={`${style.btnAdd} btn-sm mt-1`}
                    onClick={(e) => {
                      onChangeUpdate({
                        openCustodianEntityContact: true,
                      });
                    }}
                  >
                    <i className="fa fa-plus"></i>
                    {"\u00A0"} Add Custodian Entity Contact
                  </Button>
                </Col>
              </Row>
            )}
            <CustodianEntityContact
              openContact={openCustodianEntityContact}
              onChangeUpdate={onChangeUpdate}
              callApi={props.callApi}
              setContact={setContact}
              contacts={custodian.Contact}
              EditContact={EditContact}
              updateContact={updateContact}
              isEditCustodianEntity={props.isEditCustodianEntity}
              deleteContact={deleteContact}
            />
            {openCustodianEntityClearingHouse ? (
              <div></div>
            ) : (
              <Row>
                <Col>
                  <Button
                    color="primary"
                    className={`${style.btnAdd} btn-sm mt-1`}
                    onClick={(e) => {
                      onChangeUpdate({
                        openCustodianEntityClearingHouse: true,
                      });
                    }}
                  >
                    <i className="fa fa-plus"></i>
                    {"\u00A0"} Add Custodian Entity Clearing House
                  </Button>
                </Col>
              </Row>
            )}

            <CustodianEntityClearingHouse
              openClearingHouse={openCustodianEntityClearingHouse}
              onChangeUpdate={onChangeUpdate}
              callApi={props.callApi}
              setClearingHouse={setClearingHouse}
              clearingHouses={custodian.ClearingHouse}
              EditClearingHouse={EditClearingHouse}
              updateClearingHouse={updateClearingHouse}
              deleteClearingHouse={deleteClearingHouse}
            />

            {openCustodianEntityCodeType ? (
              <div></div>
            ) : (
              <Row>
                <Col>
                  <Button
                    color="primary"
                    className={`${style.btnAdd} btn-sm mt-1`}
                    onClick={(e) => {
                      onChangeUpdate({
                        openCustodianEntityCodeType: true,
                      });
                    }}
                  >
                    <i className="fa fa-plus"></i>
                    {"\u00A0"} Add Custodian Entity Code Type
                  </Button>
                </Col>
              </Row>
            )}

            <CustodianEntityCodeType
              openCodeType={openCustodianEntityCodeType}
              onChangeUpdate={onChangeUpdate}
              callApi={props.callApi}
              setCodeType={setCodeType}
              CodeTypes={custodian.CodeType}
              EditCodeType={EditCodeType}
              updateCodeType={updateCodeType}
              deleteCodeType={deleteCodeType}
            />
          </React.Fragment>
        )}
      </Container>

      <ModalFooter>
        {messageConfirmCustodianEntity ? (
          <div style={{ color: "#2cb15a" }}>
            {messageErrors.length > 0 ? (
              <React.Fragment>
                {messageErrors.map((m, index) => (
                  <div style={m.Code == 400 ? { color: "red" } : { color: "green" }}>{m.Description}</div>
                ))}
              </React.Fragment>
            ) : (
              <React.Fragment>
                {props.isEditCustodianEntity
                  ? "Custodian Entity was successfully updated"
                  : "Custodian Entity was successfully created"}
              </React.Fragment>
            )}
          </div>
        ) : (
          <div></div>
        )}
        <Button color="light" onClick={props.CloseCustodianEntity}>
          Close
        </Button>
        {messageConfirmCustodianEntity ? (
          <div></div>
        ) : (
          <LaddaButton
            className={classnames("btn btn-ladda btn-primary")}
            loading={loadingConfirmCustodianEntity}
            onClick={() => confirm()}
            data-style={EXPAND_RIGHT}
          >
            {props.isEditCustodianEntity ? "Update" : "Confirm"}
          </LaddaButton>
        )}
      </ModalFooter>
    </Modal>
  );
};

const EmptyClearingHouses = () => (
  <tr className={style.empty} style={{ textAlign: "center" }}>
    <td colSpan="4">
      <h5>No Clearing Houses</h5>
    </td>
  </tr>
);

export function validationsCustodianEntity() {
  return {
    CustodianEntityName: { empty: true },
    LegalInstitutionCode: { empty: true },
    LegalCustodianCode: { empty: true },
    // CustodianEntityAddress: {empty: true},
    // CustodianEntityURL: {empty: true},
    CustodianEntityPendingLimit: { empty: true },
    CountryId: { empty: true },
    CustodianEntityTAXId: { empty: true },
    //CustodianEntityIntroducedBy: {empty: true},
    //CustodianEntitySwift: {empty: true},
    //CustodianEntityNotes: {empty: true}
  };
}

export default CustodianEntity;
